import { getGlobalConfig } from '@/utils/globalConfig'

function getAssetUrl (assetPath) {
  return getGlobalConfig('ASSETS_URL', '/public') + assetPath
}

export { getAssetUrl }
